<script setup lang="ts">

import VideoBox from "@/core/components/icons/VideoBox.vue";
import {Play} from "@lucide/vue";
import useVideos from "@/video/composables/useVideos";
import {computed} from "vue";
import VideoItem from "@/video/components/VideoItem.vue";
import Icon from "@/core/components/icon/Icon.vue";
import {useRouter} from "vue-router";

const router = useRouter();

const {data} = useVideos({
    page: 1,
    limit: 2,
    tags: ['pinned']
});

const videos = computed(() => {
    return data.value?.data ?? [];
});
</script>

<template>
  <div class="flex flex-col space-y-1">
    <div class="flex flex-row items-center gap-2">
      <div class="bg-white rounded-lg flex pr-4 hover:opacity-75 cursor-pointer" @click="router.push({name: 'tutorial'})">
        <div class="flex items-center gap-4">
          <VideoBox :size="40" class="rounded-md shrink-0" />
          <div class="font-content text-sm text-primary line-clamp-1">
            Nouveau sur Apodis ?
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg flex py-1.5 pr-4 hover:opacity-75 cursor-pointer" @click="router.push({name: 'tutorial.tenant'})">
        <div class="flex items-center gap-4">
          <Icon name="mdi-school" :size="30" class="pl-3 text-primary" />
          <div class="font-content text-sm text-primary line-clamp-1">
            Formation titulaire
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg flex py-1.5 pr-4 hover:opacity-75 cursor-pointer" @click="router.push({name: 'tutorial.team'})">
        <div class="flex items-center gap-4">
          <Icon name="mdi-school" :size="30" class="pl-3 text-primary" />
          <div class="font-content text-sm text-primary line-clamp-1">
            Formation équipe
          </div>
        </div>
      </div>
    </div>
    <div v-if="videos?.length" class="flex items-center gap-2">
      <p class="text-[#FB0129] font-black">
        Nouveau&nbsp;!
      </p>
      <div
        v-for="video in videos" :key="video.id"
        class="hover:bg-lightPurple-lightest rounded-lg transition duration-200 p-1"
      >
        <VideoItem :video="video" class="bg-transparent">
          <template #icon>
            <Play class="fill-[#FB0129] text-[#FB0129] shrink-0" />
          </template>
        </VideoItem>
      </div>
    </div>
  </div>
</template>

<style scoped>
.welcome-trigger div:first-child {
    @apply !border-b-0
}

:deep(.video-title) {
    @apply text-primary line-clamp-1
}
</style>
